export default __webpack_public_path__ + "370b0c02c31250b215d34ee25f311960.png";